

exports.__esModule = true;
exports.$SingleStepModel = exports.$GuestUpgradeModel = exports.$OnboardPhoneModel = exports.$OnboardUserModel = exports.$OnboardModel = undefined;

var _squid = require('squid');

var _index = require('../fi/index');

var _directive = require('xo-form-components/src/national-id-input/directive');

var $OnboardModel = exports.$OnboardModel = _squid.$Model.extend('$OnboardModel', {
    api: new _squid.$Api({
        uri: '/api/onboard'
    }),

    init: function init() {
        this._super.init.apply(this);
        this.fiMode = this.fiMode || 'card'; // Supports card or bank
        this.bank = this.bank || new _index.$BankModel();
        this.card = this.card || new _index.$CardModel();
    },

    serialize: function serialize() {
        var data = {
            user: this.user.serialize(),
            billing_address: this.billing_address.serialize(),
            shipping_address: this.shipping_address.serialize(),
            phone: this.phone.serialize(),
            marketing_optin: this.marketingOptin,
            shipping_address_validation: this.shipping_address_validation,
            payment_experience_initiator: this.payment_experience_initiator,
            poma_flow: this.poma_flow,
            prox_flow: this.prox_flow,
            testParams: this.testParams,
            content_identifier: this.content_identifier,
            frs_optin_flow_applicable: this.frs_optin_flow_applicable, // Free Return Shipping Opt-in flow applicability flag
            frs_optin_active_flow: this.frs_optin_active_flow, // Denotes FRS opt in flow type - Active (true) or Silent (false)
            flow_eligibility_data: this.flow_eligibility_data
        };

        if (this.nationalIdModel) {
            data.nationalIdModel = {
                'secondaryIdType': this.nationalIdModel.secondaryIdType,
                'secondaryIdValue': this.nationalIdModel.secondaryIdValue
            };

            if (this.nationalIdModel.nationalId) {
                data.nationalIdModel.nationalId = {
                    type: this.nationalIdModel.nationalId.type,
                    subType: this.nationalIdModel.nationalId.subType,
                    value: this.nationalIdModel.nationalId.value
                };
            }
        }

        if (this.fiMode === 'card') {
            data.card = this.card.serialize();
        } else {
            data.bank = this.bank.serialize();
        }

        data.skipInitiateAuth = this.skipInitiateAuth;

        return data;
    }
});

var $OnboardUserModel = exports.$OnboardUserModel = _squid.$Model.extend('$OnboardUserModel', {
    serialize: function serialize() {
        var onboardUserModel = {
            first_name: this.first_name,
            last_name: this.last_name,
            email: this.email,
            password: this.password,
            countryOfResidence: this.countryOfResidence,
            country: this.country,
            dob_day: this.dob_day,
            dob_month: this.dob_month,
            dob_year: this.dob_year,
            occupation: this.occupation,
            nationality: this.nationality,
            gender_type: this.gendertype,
            place_of_birth: this.placeofbirth
        };

        if (this.nativeName) {
            onboardUserModel.nativeName = {
                first_name: this.nativeName.first_name,
                last_name: this.nativeName.last_name,
                middle_name: this.nativeName.middle_name
            };
        }

        return onboardUserModel;
    }
});

var $OnboardPhoneModel = exports.$OnboardPhoneModel = _squid.$Model.extend('$OnboardPhoneModel', {
    serialize: function serialize() {
        return {
            type: this.phoneType,
            number: this.telephone,
            countryCode: this.IntDialingCountryCode
        };
    }
});

/**
 * A model for handling onboarding guest accounts
 * into PayPal accounts (happens post transaction)
 */

var $GuestUpgradeModel = exports.$GuestUpgradeModel = _squid.$Model.extend('$GuestUpgradeModel', {
    api: new _squid.$Api({
        uri: '/api/onboard/guest-upgrade'
    }),

    serialize: function serialize() {
        var data = {
            user: this.user.serialize(),
            phone: this.phone.serialize(),
            billing_address: this.billing_address.serialize(),
            payerId: this.payerId,
            transaction: this.transaction,
            marketing_optin: this.marketing_optin,
            contentIdentifier: this.contentIdentifier,
            experienceIdentifier: this.experienceIdentifier,
            experienceChannel: this.experienceChannel,
            nationalId: this.nationalIdModel ? this.nationalIdModel.serialize() : _directive.$NationalIdModel.instance().serialize()
        };

        // append additional phone data
        data.phone.country_prefix = this.phone && this.phone.IntDialingCountryCode;

        // append additional billing_address data
        data.billing_address.normalization_status = this.billing_address && this.billing_address.normalization_status;

        return data;
    },

    serializeEmailFlow: function serializeEmailFlow() {
        var data = {
            user: this.user.serialize(),
            phone: this.phone.serialize(),
            billing_address: this.billing_address.serialize(),
            payerId: this.payerId,
            transaction: this.transaction,
            receiptId: this.receiptId,
            marketing_optin: this.marketing_optin,
            card: this.card
        };

        return data;
    }
});

var $SingleStepModel = exports.$SingleStepModel = _squid.$Model.extend('$SingleStepModel', {});

angular.value("$OnboardModel", $OnboardModel);
angular.value("$OnboardUserModel", $OnboardUserModel);
angular.value("$OnboardPhoneModel", $OnboardPhoneModel);
angular.value("$GuestUpgradeModel", $GuestUpgradeModel);
angular.value("$SingleStepModel", $SingleStepModel);
_squid.$Model;

_squid.$Api;

_index.$CardModel;

_index.$BankModel;

_directive.$NationalIdModel;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/onboard/index.js
// module id = ./components/xo-models/src/onboard/index.js
// module chunks = 1